import TextSection from "./TextSection";

const TextSectionWithProps = ({ blok }) => {
  return <TextSection title={blok.title} text={blok.text} />;
};

export default TextSectionWithProps;
